<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <Button icon="ios-arrow-back" size="small" class="mr20" @click="$router.go(-1)">返回</Button>
        <span class="ivu-page-header-title mr20" v-text="$route.meta.title"></span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="formData" :model='deviceData' label-position="right" :label-width="200" @submit.native.prevent>
        <Row :gutter="24" type="flex">

          <Col span="24">
            <FormItem label="设备编号">
              <Input disabled="disabled" v-model="deviceData.device_sn" class="perW30"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="设备类型">
              <Input disabled="disabled" v-model="deviceData.title" class="perW30"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="所在基地">
              <Input disabled="disabled" v-model="deviceData.land_base" class="perW30"></Input>
            </FormItem>
          </Col>

          <template v-for="(item, index) in this.deviceData.thresholds" v-if="item.status">

            <Col span="24">
              <FormItem>
                <span class="setting">{{ '配置 ' + (index + 1) }} </span>
                <Button type="dashed" size="small" icon="ios-trash-outline" @click="thresholdsDel(index)"></Button>
              </FormItem>
            </Col>

            <Col span="24">
              <FormItem
                label="检测项"
                :prop="'thresholds.' + index + '.param_key'"
                :rules="{required: true, type: 'string', message: '请选择检测项', trigger: 'change'}"
              >
                <RadioGroup type="button" v-model="item.param_key">
                  <Radio v-for="(paramsItem,paramsIndex) in deviceParams" :key="paramsIndex" :label="paramsItem.key">
                    {{ paramsItem.name }}
                  </Radio>
                </RadioGroup>
              </FormItem>
            </Col>

            <Col span="24">
              <FormItem
                label="区间最低值"
                :prop="'thresholds.' + index + '.min_value'"
                :rules="{required: true, type: 'number', message: '请输入区间最低值', trigger: 'blur'}"
              >
                <InputNumber v-model="item.min_value" class="input-number"/>
              </FormItem>
            </Col>

            <Col span="24">
              <FormItem
                label="区间最高值"
                :prop="'thresholds.' + index + '.max_value'"
                :rules="{required: true, type: 'number', message: '请输入区间最高值', trigger: 'blur'}"
              >
                <InputNumber v-model="item.max_value" class="input-number"/>
              </FormItem>
            </Col>

            <Col span="24">
              <FormItem
                label="区间类型"
                :prop="'thresholds.' + index + '.type'"
                :rules="{required: true, type: 'number', message: '请选择区间类型', trigger: 'change'}"
              >
                <RadioGroup type="button" v-model="item.type">
                  <Radio :label="1">正常区间</Radio>
                  <Radio :label="2">异常区间(预警)</Radio>
                </RadioGroup>
              </FormItem>
            </Col>

            <Col span="24" v-if="item.type === 2">
              <FormItem
                label="预警消息"
                :prop="'thresholds.' + index + '.message'"
                :rules="{required: true, type: 'string', message: '请输入预警消息内容', trigger: 'blur'}"
              >
                <Input type="textarea" :autosize="{minRows: 2,maxRows: 5}" v-model="item.message" placeholder="请输入预警消息内容" class="warning-message"/>
              </FormItem>
            </Col>

          </template>

          <Col span="24">
            <FormItem>
                <Button type="dashed" long @click="thresholdsAdd" icon="plus-round" style="width: 200px;">添加配置</Button>
            </FormItem>
          </Col>

        </Row>

        <FormItem>
          <Button type="primary" class="submission" @click="submitFormData">提交</Button>
        </FormItem>

      </Form>
    </Card>
  </div>
</template>

<script>
import {deviceInfoApi, deviceSaveApi} from '@/api/device/device'
import {forEach} from "@/libs/tools";

export default {
  name: 'deviceThresholds',
  data() {
    return {
      deviceData: {
        id: 0,
        device_sn: '',
        title: '',
        land_base: '',
        thresholds: [],
      },
      deviceParams: [],
    }
  },
  mounted() {
    if (this.$route.params.id !== '0' && this.$route.params.id) {
      this.loadFormData(this.$route.params.id)
    }
  },
  methods: {
    // 提交数据
    submitFormData() {

      let thresholds = [];
      let status_num = 0;

      this.deviceData.thresholds.forEach((item, index) => {
        if (item.status) {
          status_num++
        }
        if (item.id || item.status) {
          thresholds.push(item)
        }
      });

      if (status_num === 0 || thresholds.length === 0) {
        this.$Message.error('请至少添加一个配置')
        return false
      }

      this.$refs.formData.validate((valid) => {
        if (!valid) {
          // 验证失败 停止提交
          this.$Message.error('请检查输入内容!');
          return false;
        } else {
          // 验证通过 请求接口
          deviceSaveApi({
            id: this.deviceData.id,
            thresholds: thresholds
          }).then(res => {
            if (res.code === 200) {
              this.$Message.success('成功')
              setTimeout(() => {
                this.$router.go(-1)
              }, 500)
            } else {
              this.$Message.error(res.msg)
            }
          }).catch(res => {
            this.$Message.error(res.msg)
          })
        }
      })
    },

    // 编辑加载数据
    loadFormData(id) {
      deviceInfoApi(id).then(res => {
        // 数据赋值
        this.deviceData = res.data
        this.deviceParams = res.data.params
        let thresholds = []
        forEach(res.data.thresholds, (item, index) => {
          thresholds.push({
            id: item.id,
            param_key: item.param_key,
            min_value: item.min_value,
            max_value: item.max_value,
            message: item.message,
            type: item.type,
            status: 1
          })
        })
        this.deviceData.thresholds = []
        this.deviceData.thresholds = thresholds

      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },

    // 添加配置
    thresholdsAdd() {
      let param_key = ''
      if (this.deviceParams.length > 0) {
        param_key = this.deviceParams[0].key;
      }
      this.deviceData.thresholds.push({
        id: 0,
        param_key: param_key,
        min_value: 0,
        max_value: 0,
        message: '',
        type: 1,
        status: 1
      })
    },

    // 删除配置
    thresholdsDel(index) {
      // 修改status
      this.deviceData.thresholds[index].status = 0
    },
  }
}
</script>

<style>

.input-number {
  width: 140px;
}

.warning-message {
  width: 500px;
}

.setting {
  font-size: 1.17em;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  font-weight: bold;
  unicode-bidi: isolate;
  margin-right: 10px;
}
</style>
